import { fetch } from '@/utils/http'

export default {
  contractDetact: params => fetch('post', '/cbaas-service/v1/paillier/contractDetact', params),

  contractInstall: params => fetch('post', '/cbaas-service/v1/paillier/contractInstall', params),

  encrypt: params => fetch('post', '/cbaas-service/v1/paillier/encrypt', params),

  decrypt: params => fetch('post', '/cbaas-service/v1/paillier/decrypt', params),

  compute: params => fetch('post', '/cbaas-service/v1/paillier/compute', params),

  queryResult: params => fetch('post', '/cbaas-service/v1/paillier/queryResult', params)
}
